/* @flow */
import React from 'react';
import userAgent from 'lib/currentUserAgent';

import './styles/DebugInfoView.scss';

class DebugInfoView extends React.Component {
  state = userAgent.result;

  render() {
    return (
      <table className="DebugInfoView">
        <tbody>
          <tr>
            <td>UserAgent</td>
            <td colSpan="2">{this.state.ua}</td>
          </tr>
          <tr>
            <td>Browser</td>
            <td>{this.state.browser.name || 'N/A'}</td>
            <td>{this.state.browser.version || 'N/A'}</td>
          </tr>
          <tr>
            <td>Engine</td>
            <td>{this.state.engine.name || 'N/A'}</td>
            <td>{this.state.engine.version || 'N/A'}</td>
          </tr>
          <tr>
            <td>OS</td>
            <td>{this.state.os.name || 'N/A'}</td>
            <td>{this.state.os.version || 'N/A'}</td>
          </tr>
          <tr>
            <td>Device</td>
            <td>{this.state.device.type || 'N/A'}</td>
            <td>{this.state.device.vendor || 'N/A'}</td>
          </tr>
          <tr>
            <td>CPU</td>
            <td colSpan="2">{this.state.cpu.architecture || 'N/A'}</td>
          </tr>
          <tr style={{ verticalAlign: 'top' }}>
            <td>Cookie</td>
            <td colSpan="2">{document.cookie}</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default DebugInfoView;



// WEBPACK FOOTER //
// ./src/misc/components/DebugInfoView.jsx